import type { ReactNode } from 'react';

export const symbol_pen_size_4: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M210-300.14Q210-338 236-364l360-360q26.18-26 64.09-26Q698-750 724-723.86t26 64Q750-622 724-596L364-236q-26.18 26-64.09 26Q262-210 236-236.14t-26-64Z"
		/>
	</svg>
);
